import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nowa restauracja',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nowe demo',
        [CompanyCreationModes.full]: 'Nowa restauracja',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Informacje o restauracji',
        [CompanyCreationSteps.BusinessInfo]: 'Informacje o firmie',
        [CompanyCreationSteps.AdditionalLocations]: 'Dodatkowe restauracje',
      },
    },
    business_profile: {
      legal_info: 'Dane prawne',
      owner_info: 'Dane właściciela',
    },
    recently_created: 'Ostatnio utworzone',
  },
  form: {
    franchise: {
      label: 'Utwórz restaurację',
      tooltip:
        'Wybierz, czy tworzysz zupełnie nową markę, czy dodajesz tę restaurację do istniejącej marki w naszym systemie.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Utwórz nową markę',
          tooltip: 'Zaczynamy od zera — brak istniejącej marki lub restauracji',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Dodaj tę restaurację do istniejącej marki',
          tooltip: 'Należy do marki już istniejącej w systemie',
        },
      },
    },
    restaurants: {
      label: 'Powiązane restauracje',
    },

    business_profile: {
      label: 'Kto jest właścicielem?',
      tooltip:
        'Czy ta restauracja należy do właściciela/firmy już istniejącej w naszym systemie (np. „Luís Pizza GmbH")? <br/> Jeśli tak, wybierz istniejący profil właściciela/firmy. W przeciwnym razie utwórz nowy.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Utwórz nowy profil właściciela/firmy',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Użyj istniejącego profilu właściciela/firmy',
      },
    },
    business_type: {
      label: 'Typ działalności',
      placeholder: 'Wybierz typ działalności',
      options: {
        [BusinessType.Company]: 'Firma',
        [BusinessType.Individual]: 'Jednoosobowa działalność',
      },
    },
    display_name: {
      label: 'Nazwa restauracji',
      placeholder: 'Nazwa przyjazna',
    },
    legal_name: {
      label: 'Nazwa prawna',
      placeholder: 'Nazwa prawna',
    },
    owner_first_name: {
      label: 'Imię osoby kontaktowej',
      placeholder: 'Jan',
    },
    owner_last_name: {
      label: 'Nazwisko osoby kontaktowej',
      placeholder: 'Kowalski',
    },
    owner_phone_number: {
      label: 'Telefon osoby kontaktowej',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail osoby kontaktowej',
      placeholder: 'Wprowadź e-mail',
    },
    password: {
      label: 'Hasło',
      placeholder: 'Wprowadź hasło',
    },

    additional_companies: {
      label: 'Dodatkowe restauracje pod tą samą marką',
      tooltip:
        'Czy są inne restauracje pod tą samą marką co {{company}}? <br/> Jeśli tak, kliknij „Dodaj restaurację", aby dodać kolejne lokalizacje. Jeśli to ten sam właściciel, ale inna marka, nie dodawaj tutaj — utwórz osobno.',
    },
  },
  labels: {
    create_demo: 'Utwórz demo',
    create_company: 'Utwórz restaurację',
    business_type: 'Typ działalności',
    display_name: 'Nazwa przyjazna',
    legal_name: 'Nazwa prawna',
    owner_name: 'Nazwa właściciela',
    address: 'Adres',
  },
  fields: {
    name: 'Nazwa',
    created_at: 'Utworzono',
    actions: 'Akcje',
  },

  buttons: {
    add_restaurant: '+ Dodaj restaurację',
    continue: 'Kontynuuj',
    back: 'Wstecz',
    create: 'Utwórz restaurację',
    delete: 'Usuń',
  },
  popups: {
    delete_demo: {
      title: 'Czy na pewno usunąć?',
    },
  },
  toasts: {
    company_created: 'Restauracja utworzona pomyślnie',
    failed_to_create_company: 'Nie udało się utworzyć restauracji',
    failed_to_delete_demo: 'Nie udało się usunąć dema',
    demo_got_deleted: 'Demo usunięte pomyślnie',
    failed_to_load_recently_created_companies: 'Nie udało się załadować ostatnio utworzonych restauracji',
  },
};
